<nz-card>
  <nz-skeleton [nzActive]="true"
    [nzLoading]="true"
    [nzAvatar]="{size: 'large', shape: 'square'}"
    [nzParagraph]="{ rows: 9 }">
  </nz-skeleton>
</nz-card>